/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useEffect, useState } from 'react';
import { Box, Checkbox, FormControlLabel, FormGroup, Grid, Tab } from '@mui/material';
import { CheckBoxComp, DatePickers, DialogForm, Gridview, IActions, IDialogActions, ISnackbarAlert, SelectField, SnackbarAlert, TextFieldInput, TextFieldReadOnly } from '../../../shared/components';
import { GenericService } from '../../../shared/services';
import { ListId, LocalStorange } from '../../../shared/environment';
import { VacancyDTO, UserDTO, ValueListDTO, CompanyFilterDTO, UserFilterDTO, VacancyFilterDTO } from '../../../shared/interfaces';
import { formatDateTime } from '../../../shared/utils';
import { CompanyDTO } from '../../../shared/interfaces/corpSphere/CompanyDTO';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { use } from 'i18next';
import { GridColDef } from '@mui/x-data-grid';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

interface IVacancyReportProps {
    setIsOpenMaintenance: (value: boolean) => void;
    isOpenMaintenance: boolean;
    setActionExecuted: (value: boolean) => void;
}

export const VacancyReport: React.FC<IVacancyReportProps> = ({ isOpenMaintenance, setIsOpenMaintenance, setActionExecuted }) => {

    const [vacancyDTO, setVacancyDTO] = useState<VacancyDTO>();
    const [vacancyList, setVacancyList] = useState<VacancyDTO[]>([]);
    const [vacancyFilterDTO, setVacancyFilterDTO] = useState<VacancyFilterDTO>();

    const [loading, setLoading] = useState(false);
    const [snackBarAlert, setSnackBarAlert] = useState<ISnackbarAlert>();
    const [isOpenMessage, setIsOpenMessage] = useState(false);

    const userInfo = JSON.parse(localStorage.getItem(LocalStorange.USERINFO) || '');
    const { t } = useTranslation();

    useEffect(() => {
        setVacancyFilterDTO({
            ...vacancyFilterDTO,
            code: '',
            jobTitleId: '',
            seniorityId: '',
            typeId: '',
            statusId: '',
            requesterId: '',
            managerId: '',
            recruiterId: '',
            companyId: ''
        } as VacancyFilterDTO);

        handleVacancyGetAllViewAsync();

        // handleGetPermission(ListId.talentsphere.vacancyId, setAccessRolePermissionDTO);
    }, []);

    useEffect(() => {
        setVacancyDTO({
            ...vacancyDTO,
        } as VacancyDTO);

    }, [isOpenMaintenance]);

    useEffect(() => {
        handleVacancyGetAllViewAsync();
    }, [vacancyFilterDTO]);

    const handleVacancyGetAllViewAsync = useCallback(async () => {
        if (vacancyFilterDTO === undefined)
            return;
        // if(accessRolePermissionDTO?.allowGetAllView == undefined)
        //     return; 
        // if(!accessRolePermissionDTO?.allowGetAllView) {
        //     showMessage('There is no permission for get all view.', 'info');
        //     return;
        // }
        GenericService.GetAllViewAsync1('talentsphere.reportvacancy', vacancyFilterDTO, setActionExecuted, setLoading, setVacancyList, showMessage, true);
    }, [vacancyFilterDTO]);

    function showMessage(message: string, type: 'error' | 'info' | 'success' | 'warning') {
        const msg: ISnackbarAlert = {
            id: 'message',
            message: message,
            type: type,
        };
        setSnackBarAlert(msg);
        setIsOpenMessage(true);
    }

    const actions: IDialogActions[] = [
        { id: 'close', text: t('reportVacancy.maintenanceButton.close'), icon: 'close_outlined', iconColor: 'secondary', setAction: () => void undefined },
    ];

    const columns: GridColDef[] = [
        { field: 'code', headerName: t('reportVacancy.columns.code'), width: 150 },
        { field: '', headerName: t('reportVacancy.columns.flagger'), width: 150 },
        { field: 'jobTitle', headerName: t('reportVacancy.columns.jobTitle'), width: 200, },
        { field: 'seniority', headerName: t('reportVacancy.columns.seniority'), width: 200, },
        { field: 'type', headerName: t('reportVacancy.columns.type'), width: 200, },
        { field: 'recruiter', headerName: t('reportVacancy.columns.recruiter'), width: 200, },
        { field: 'hiringType', headerName: t('reportVacancy.columns.hiringType'), width: 200, },
        { field: 'budgetEmployed', headerName: t('reportVacancy.columns.budgetCLT'), width: 200, },
        { field: 'budgetSelfEmployed', headerName: t('reportVacancy.columns.budgetPJ'), width: 200, },
        { field: 'company', headerName: t('reportVacancy.columns.company'), width: 200, },
        { field: 'requester', headerName: t('reportVacancy.columns.requester'), width: 200, },       
        { field: 'manager', headerName: t('reportVacancy.columns.serviceManager'), width: 200, },
        { field: 'status', headerName: t('reportVacancy.columns.status'), width: 200, },
        { field: 'openingDateTime', headerName: t('reportVacancy.columns.openingDateTime'), width: 200, },
        { field: 'closingDateTime', headerName: t('reportVacancy.columns.closingDateTime'), width: 200, },
        { field: 'openDays', headerName: t('reportVacancy.columns.openDays'), width: 200, },
        { field: 'inScreening', headerName: t('reportVacancy.columns.inScreening'), width: 200, },
        { field: 'inScreeningApproved', headerName: t('reportVacancy.columns.inScreeningApproved'), width: 200, },
        {
            field: 'inScreeningApprovedPercent',
            headerName: t('reportVacancy.columns.inScreeningPercentApproved'),
            width: 200,
            valueFormatter: (params) => {
                const value = params.value;
                return value ? `${value.toFixed(2)}%` : '0%';
            }
        },
        { field: 'interviewScheduleWithHR', headerName: t('reportVacancy.columns.interviewScheduleWithHR'), width: 200, },
        { field: 'interviewScheduleWithHRApproved', headerName: t('reportVacancy.columns.interviewScheduleWithHRApproved'), width: 200, },
        {
            field: 'interviewScheduleWithHRApprovedPercent',
            headerName: t('reportVacancy.columns.interviewScheduleWithHRPercentApproved'),
            width: 200,
            valueFormatter: (params) => {
                const value = params.value;
                return value ? `${value.toFixed(2)}%` : '0%';
            }
        },
        { field: 'scheduledInterviewWithTechnicalArea', headerName: t('reportVacancy.columns.interviewScheduleWithTechnicalArea'), width: 200, },
        { field: 'scheduledInterviewWithTechnicalAreaApproved', headerName: t('reportVacancy.columns.interviewScheduleWithTechnicalAreaApproved'), width: 200, },
        {
            field: 'scheduledInterviewWithTechnicalAreaApprovedPercent',
            headerName: t('reportVacancy.columns.interviewScheduleWithTechnicalAreaPercentApproved'),
            width: 200,
            valueFormatter: (params) => {
                const value = params.value;
                return value ? `${value.toFixed(2)}%` : '0%';
            }
        },
        { field: 'underAnalysisByTheCustomer', headerName: t('reportVacancy.columns.interviewScheduleWithCustomer'), width: 200, },
        { field: 'preApproved', headerName: t('reportVacancy.columns.interviewScheduleWithCustomerPreApproved'), width: 200, },
        { field: 'approvedByCustomer', headerName: t('reportVacancy.columns.interviewScheduleWithCustomerApproved'), width: 200, },
        {
            field: 'approvedByCustomerPercent',
            headerName: t('reportVacancy.columns.interviewScheduleWithCustomerPercentApproved'),
            width: 200,
            valueFormatter: (params) => {
                const value = params.value;
                return value ? `${value.toFixed(2)}%` : '0%';
            }
        },
        { field: 'disapprovedByTheCustomer', headerName: t('reportVacancy.columns.interviewScheduleWithCustomerDisapproved'), width: 200, },
        // { field: 'offerLetterSent', headerName: 'Offer Letter Sent', width: 200, },
        // { field: 'acceptedOfferLetter', headerName: 'Accepted Offer Letter', width: 200, },
        // { field: 'disapprovedByHR', headerName: 'Disapproved By HR', width: 200, },
        // { field: 'disapprovedByTheTechnicalArea', headerName: 'Disapproved By The Technical Area', width: 200, },
        // { field: 'dispensed', headerName: 'Dispensed', width: 200, },
        // { field: 'withdrawn', headerName: 'Withdrawn', width: 200, },

        // { field: 'description', headerName: 'Descrição', width: 400 },
        // { field: 'creationDateTime', headerName: 'Data de Criação', width: 160, valueFormatter: parms => moment(parms.value).format('DD/MM/YYYY HH:mm:ss') },
    ];

    const GridActions: IActions[] = [
        // { field: 'edit', headerName: '', icon: 'preview_outlined', iconToolTip: 'Editar', iconColor: 'primary', setAction: () => undefined },
        // { field: 'delete', headerName: '', icon: 'delete_outlined', iconToolTip: 'Excluir', iconColor: 'error', setAction: () => undefined   },
    ];
    
    return (
        <React.Fragment>
            {isOpenMessage && (
                <SnackbarAlert
                    snackBarAlert={snackBarAlert}
                    setIsOpen={setIsOpenMessage}
                    isOpen={isOpenMessage}
                />
            )}
            <DialogForm
                title={t('vacancy.vacancyReport.dialogForm.title')}
                icon='checked_outlined'
                setIsOpen={setIsOpenMaintenance}
                isOpen={isOpenMaintenance}
                fullWidth={true}
                maxWidth={'xl'}
                actions={actions}
                loading={loading}
            >
                <React.Fragment>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                            <Gridview 
                                rowId={'id'}
                                rows={vacancyList}
                                columns={columns}
                                actions={GridActions}
                                loading={loading}
                            />
                        </Grid>
                    </Grid>
                </React.Fragment>
            </DialogForm>
        </React.Fragment>
    );
};